export  const headers = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    { field: "prd_code", headerName: "Codigo", width: 100 },
    { field: "art_descripcion", headerName: "Articulo", width: 300 },
    { field: "price", headerName: "Precio", width:90 },
    { field: "quantity", headerName: "Cant.", width: 60},
    {
      field: "observacion",
      headerName: "Observación",
      width: 150,
      renderCell: (params) => {
        const texto = params.value;
        if (!texto) return null;
    
        return (
          <button
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => params.api.getRow(params.id)?.handleOpenModalObs(texto)}
          >
            Ver
          </button>
        );
      }
    },    
    { field: "total_amount", headerName: "Total", width: 90 },
  ];